// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.CreatorCardOnHover {
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  display: block;
  position: relative;
}
.CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee {
  width: auto;
  height: 84px;
  padding: 0;
  box-sizing: border-box;
}
.CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee [class^=dist_button-card] {
  width: inherit;
}
.CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee [class^=dist_button-card] [class^=dist_container-card]:not([class*=dist_container-card-]) {
  flex: 1 1;
}
.CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee [class^=dist_title] {
  max-width: 173px;
}
.CreatorCardOnHover .CreatorCardFetcher .CreatorCardMiniWithTolgee [class*=dist_checkbox-creator] {
  top: 5px;
  left: 0;
}
.CreatorCardOnHover .CreatorCardOnHover-popover {
  position: absolute;
  top: 18px;
  padding: 8px 0 0;
  z-index: 2;
}
.CreatorCardOnHover .CreatorCardOnHover-popover span {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.CreatorCardOnHover .CreatorCardOnHover-popover button {
  width: 125px;
}
.CreatorCardOnHover .CreatorCardOnHover-popoverContent {
  border: 1px solid var(--gray_light2);
  background: var(--base_color2);
  padding: 8px;
  border-radius: 4px;
}
.CreatorCardOnHover .CreatorCardOnHover-popoverContent .CreatorCard-second-column .title {
  max-width: 180px;
}
.CreatorCardOnHover .CreatorCardOnHover-popoverContent-withPadding {
  padding: 12px;
}
.CreatorCardOnHover .CreatorCardOnHover-truncate {
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  display: block;
  font-size: 14px;
  color: var(--color_primary_500);
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.CreatorCardOnHover .CreatorCardOnHover-truncate a {
  color: var(--color_primary_500);
}
.CreatorCardOnHover > h6 {
  display: flex;
}
.CreatorCardOnHover > h6 .creatorIncompleteTitle {
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
.CreatorCardOnHover > h6 .CreatorIncomplete-title-icon {
  margin-left: 5px;
}

.CreatorCardOnHover-InsertCreator-Toast,
.CreatorCardOnHover-UpdateCreator-Toast {
  display: flex;
  gap: 20px;
  align-items: center;
  font-size: 14px;
}
.CreatorCardOnHover-InsertCreator-Toast .thumbnail-component-container,
.CreatorCardOnHover-UpdateCreator-Toast .thumbnail-component-container {
  flex-shrink: 0;
}
.CreatorCardOnHover-InsertCreator-Toast .thumbnail-component-container > img,
.CreatorCardOnHover-InsertCreator-Toast .thumbnail-component-container > svg,
.CreatorCardOnHover-UpdateCreator-Toast .thumbnail-component-container > img,
.CreatorCardOnHover-UpdateCreator-Toast .thumbnail-component-container > svg {
  border-radius: 50%;
  width: 56px;
  height: 56px;
  background-color: #a7b0be;
}
.CreatorCardOnHover-InsertCreator-Toast .toast-highlight,
.CreatorCardOnHover-UpdateCreator-Toast .toast-highlight {
  font-weight: var(--bold_weight);
  color: var(--base_color1);
}
.CreatorCardOnHover-InsertCreator-Toast .toast-link,
.CreatorCardOnHover-UpdateCreator-Toast .toast-link {
  font-weight: var(--bold_weight);
  color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/CreatorCardOnHover/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,8BAAA;EAAA,2BAAA;EAAA,sBAAA;EACA,cAAA;EACA,kBAAA;AAeF;AAZI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;AAcN;AAZM;EACE,cAAA;AAcR;AAZQ;EACE,SAAA;AAcV;AAVM;EACE,gBAAA;AAYR;AATM;EACE,QAAA;EACA,OAAA;AAWR;AANE;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AAQJ;AANI;EDtCF,oBAAA;EACA,aCsCwB;EDrCxB,qBCqCwB;EDpCxB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACqDtC;AAVI;EACE,YAAA;AAYN;AARE;EACE,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AAUJ;AAPM;EACE,gBAAA;AASR;AALI;EACE,aAAA;AAON;AAHE;EACE,8BAAA;EAAA,2BAAA;EAAA,sBAAA;EACA,cAAA;EAEA,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIJ;AAFI;EACE,+BAAA;AAIN;AAAE;EACE,aAAA;AAEJ;AAAI;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AAEN;AACI;EACE,gBAAA;AACN;;AAIA;;EAEE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AADF;AAGE;;EACE,cAAA;AAAJ;AAEI;;;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AAEN;AAEE;;EACE,+BAAA;EACA,yBAAA;AACJ;AAEE;;EACE,+BAAA;EACA,+BAAA;AACJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import '../../mixins.scss';\n\n.CreatorCardOnHover {\n  max-width: fit-content;\n  display: block;\n  position: relative;\n\n  .CreatorCardFetcher {\n    .CreatorCardMiniWithTolgee {\n      width: auto;\n      height: 84px;\n      padding: 0;\n      box-sizing: border-box;\n\n      [class^='dist_button-card'] {\n        width: inherit;\n\n        [class^='dist_container-card']:not([class*='dist_container-card-']) {\n          flex: 1;\n        }\n      }\n\n      [class^='dist_title'] {\n        max-width: 173px;\n      }\n\n      [class*='dist_checkbox-creator'] {\n        top: 5px;\n        left: 0;\n      }\n    }\n  }\n\n  .CreatorCardOnHover-popover {\n    position: absolute;\n    top: 18px;\n    padding: 8px 0 0;\n    z-index: 2;\n\n    span {\n      @include line-clamp(1);\n    }\n\n    button {\n      width: 125px;\n    }\n  }\n\n  .CreatorCardOnHover-popoverContent {\n    border: 1px solid var(--gray_light2);\n    background: var(--base_color2);\n    padding: 8px;\n    border-radius: 4px;\n\n    .CreatorCard-second-column {\n      .title {\n        max-width: 180px;\n      }\n    }\n\n    &-withPadding {\n      padding: 12px;\n    }\n  }\n\n  .CreatorCardOnHover-truncate {\n    max-width: fit-content;\n    display: block;\n\n    font-size: 14px;\n    color: var(--color_primary_500);\n    line-height: 18px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    a {\n      color: var(--color_primary_500);\n    }\n  }\n\n  > h6 {\n    display: flex;\n\n    .creatorIncompleteTitle {\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n      max-width: 150px;\n    }\n\n    .CreatorIncomplete-title-icon {\n      margin-left: 5px;\n    }\n  }\n}\n\n.CreatorCardOnHover-InsertCreator-Toast,\n.CreatorCardOnHover-UpdateCreator-Toast {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  font-size: 14px;\n\n  .thumbnail-component-container {\n    flex-shrink: 0;\n\n    > img,\n    > svg {\n      border-radius: 50%;\n      width: 56px;\n      height: 56px;\n      background-color: #a7b0be;\n    }\n  }\n\n  .toast-highlight {\n    font-weight: var(--bold_weight);\n    color: var(--base_color1);\n  }\n\n  .toast-link {\n    font-weight: var(--bold_weight);\n    color: var(--color_primary_500);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
